import * as React from 'react'

import { cn } from '../../lib'
import { Typography } from '../typography'

export type ChipV1Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  selected?: boolean
}

/**
 * @deprecated Use Chip instead
 */
const ChipV1 = ({ className, children, selected, ...props }: ChipV1Props) => {
  return (
    <button
      {...props}
      className={cn(
        ['px-2 py-[11px] border rounded-lg'],
        ['data-[selected=selected]:border-primary', 'data-[selected=selected]:bg-green-100'],
        ['data-[selected=un-selected]:border-gray-200', 'data-[selected=un-selected]:bg-white'],
        className,
      )}
      data-selected={selected ? 'selected' : 'un-selected'}
      aria-selected={selected}
    >
      <Typography size="h5">{children}</Typography>
    </button>
  )
}

ChipV1.displayName = 'ChipV1'

export default ChipV1
